var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { ClassNames } from "../ClassNames";
import * as EvHandlers from "../EventHandlers";
import { DeviceDetect } from "sb-resp-utils";
import { observable, action } from "mobx";
export class Controller {
    constructor(config) {
        this.config = config;
        this.eventHandlers = EvHandlers;
        this.isDesktop = DeviceDetect.getInstance().isDesktop;
        this.isInIframe = (typeof this.config.isInIframe !== "undefined") ? this.config.isInIframe : this.getIsInIframe();
        this.shouldShow = false;
        this.setClassName = "";
        this.scrollPosition = 0;
    }
    manageContentElClass(className) {
        this.setClassName = className;
    }
    freezeBodyScroll() {
        if (!this.isDesktop && !this.isInIframe) {
            this.scrollPosition = window.pageYOffset;
            document.body.classList.add(ClassNames.modalOpenedFixed);
            document.body.style.top = `-${this.scrollPosition}px`;
        }
    }
    unfreezeBodyScroll() {
        if (!this.isDesktop && !this.isInIframe) {
            document.body.classList.remove(ClassNames.modalOpenedFixed);
            document.body.style.removeProperty("top");
            window.scrollTo(0, this.scrollPosition);
        }
    }
    show() {
        this.execute(this.config.beforeShowCallback);
        this.setVisibility(true);
        document.body.classList.add(ClassNames.modalOpened);
        this.freezeBodyScroll();
        setTimeout(this.execute.bind(this, this.config.afterShowCallback), 0);
        if (this.isInIframe) {
            EvHandlers.scrollToTop();
            this.manageContentElClass(ClassNames.isInIframe);
        }
        else if (typeof this.config.offsetTop !== "undefined") {
            this.manageContentElClass(ClassNames.hasOffSet);
        }
    }
    hide() {
        this.execute(this.config.beforeHideCallback);
        document.body.classList.remove(ClassNames.modalOpened);
        this.unfreezeBodyScroll();
        this.setVisibility(false);
        this.manageContentElClass("");
        setTimeout(this.execute.bind(this, this.config.afterHideCallback), 0);
        this.execute(this.config.legacyCallback);
    }
    close(e) {
        const target = e.target;
        if (target.hasAttribute("data-modal-content-wrapper")) {
            this.hide();
        }
    }
    getPaddingTop() {
        return typeof this.config.offsetTop !== "undefined" ? { paddingTop: `${this.config.offsetTop}px` } : undefined;
    }
    setVisibility(visible) {
        this.shouldShow = visible;
    }
    execute(fn) {
        typeof fn === "function" && fn(this);
    }
    getIsInIframe() {
        return window.self !== window.top;
    }
}
__decorate([
    observable,
    __metadata("design:type", Boolean)
], Controller.prototype, "shouldShow", void 0);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], Controller.prototype, "setVisibility", null);
//# sourceMappingURL=Controller.js.map